import React, {useEffect, useLayoutEffect, useRef, useState, useSyncExternalStore} from "react";
import {useAppSelector, useAppDispatch} from 'redux/hooks'
import {Divider} from "primereact/divider";
import {Button} from "primereact/button";
import {TabPanel, TabView} from "primereact/tabview";
import {Dialog} from "primereact/dialog";
import {
    setUserDialogUnzipping,
    setUserErrorFields,
    setUserField,
    setUsersDialogVisible,
    setUserTrunkIds
} from "../../../../redux/actions/actionsUsersList";
import UsersListDialogInfo from "../UserDialodInfo";
import UsersListDialogGeneralSettings from "../UsersListDialogGeneralSettings";
import UsersListDialogPersonalInfo from "../UserDialogPersonalInfo";
import UserBranchInfo from "../UserBranchInfo";
import UserDialogSettings from "../UserDialogSettings";
import UserDialogCampaign from "../UserDialogCampaign";
import {createUser, deleteUser, getPhoneDictionary, getUserDetails, getUsersManagerRolesList, updateUser} from "../../../../redux/api/apiUsersList";
import {Toast} from "primereact/toast";
import {validateUserForm} from "../../../../redux/validator/validator";
import {getNotification} from "../../../../redux/api/api";
import {getItem} from "../../../../redux/cache/cacheService";
import {codes} from "../../../../redux/notificationCodes";
import {ConfirmDialog} from "primereact/confirmdialog";
import {ProgressBar} from "primereact/progressbar";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import UserPhoneSettings from "../UserPhoneSettings";
import UserWorkSchedule from "../UserWorkSchedule/index";
import {normalizeUserWorkSchedulers} from "../userWorkSchedulers";
import {getActiveUserDialogId, publishUserDialogOwners, registerUserDialog, subscribeUserDialogOwner, unregisterUserDialog} from "../userDialogOwner";

const USER_WORK_SCHEDULE_TAB_INDEX = 4;

const UserListDialog = (props: any) => {
    const dispatch = useAppDispatch()
    // @ts-ignore
    const userData = useAppSelector(state => state.UsersListReducer.userData);
    // @ts-ignore
    const userDialogVisible = useAppSelector(state => state.UsersListReducer.dialogVisible);
    // @ts-ignore
    const errorFields = useAppSelector(state => state.UsersListReducer.errorFields);
    const user = useAppSelector(state => state.UsersReducer.userData);
    const userId = userData?.user?.id;
    const toast = useRef<Toast>(null);
    const toastBC = useRef<Toast>(null);
    const [activeIndex, setActiveIndex] = useState(0)
    const [visibleDeletedMessage, setVisibleDeletedMessage] = useState<any>(false);
    // @ts-ignore
    const userDeleteQuestionsText = useAppSelector(state => state.CompaniesListReducer.userDeleteQuestionsText);
    // @ts-ignore
    const usersActiveTableToggle = useAppSelector(state => state.UsersListReducer.usersActiveTableToggle);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as any;
    // @ts-ignore
    const dataSort = useAppSelector(state => state.UsersListReducer.dataSort);
    // @ts-ignore
    const usersDialogUnzipping = useAppSelector(state => state.UsersListReducer.usersDialogUnzipping);
    const usersManagerPermissions = checkPermissions(rolesVision, 'Users');
    // @ts-ignore
    const userTrunkIds = useAppSelector(state => state.UsersListReducer.usersTrunkIds);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    // @ts-ignore
    const detailLoading = useAppSelector(state => state.UsersListReducer.detailLoading);
    const userPermission = userData?.user?.permission;
    const roleIsBlock = !!userPermission?.roleIsBlock;
    const trunksIsBlock = !!userPermission?.trunksIsBlock;

    const {
        create: hasUsersManagerCreatePermission,
        update: hasUsersManagerUpdatePermission,
        delete: hasUsersManagerDeletePermission,
        visible: hasUsersManagerVisionPermission
    } = usersManagerPermissions;
    const hasUsersAccess = !!rolesVision?.hasOwnProperty('Users');
    const dialogPriority = props.priority ?? 1;
    const dialogOwnerIdRef = useRef(0);
    const activeDialogId = useSyncExternalStore(subscribeUserDialogOwner, getActiveUserDialogId, getActiveUserDialogId);
    const isActiveDialog = activeDialogId !== null && activeDialogId === dialogOwnerIdRef.current;

    useLayoutEffect(() => {
        const id = registerUserDialog(dialogPriority);
        dialogOwnerIdRef.current = id;
        publishUserDialogOwners();
        return () => unregisterUserDialog(id);
    }, [dialogPriority]);

    useEffect(() => {
        if (!isActiveDialog) {
            return;
        }
        if (!hasUsersAccess) {
            dispatch(setUserTrunkIds(null));
            return;
        }
        if (!userDialogVisible) {
            return;
        }
        if (detailLoading) {
            return;
        }
        if (!roleIsBlock) {
            dispatch(getUsersManagerRolesList(jwtToken?.jwtToken));
        }
        dispatch(getPhoneDictionary(jwtToken?.jwtToken));
        dispatch(setUserTrunkIds(null));
    }, [isActiveDialog, hasUsersAccess, userDialogVisible, detailLoading, roleIsBlock, jwtToken?.jwtToken]);

    useEffect(() => {
        if (!isActiveDialog) {
            return;
        }
        dispatch(setUserTrunkIds(null));
    }, [isActiveDialog, userId]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (!isActiveDialog) {
            return;
        }
        if (props.branchClick) {
            const queuesShift = userData?.user?.id ? 1 : 0;
            setActiveIndex(userData?.user?.branchId ? USER_WORK_SCHEDULE_TAB_INDEX + 1 + queuesShift : 0);
            props.setBranchClick(false);
        } else {
            setActiveIndex(0);
        }
        dispatch(setUserErrorFields(null));
        dispatch(setUserField({section: 'user', fieldName: 'actionByUserId', value: user.userId}));
    }, [isActiveDialog, userDialogVisible])

    useEffect(() => {
        if (!isActiveDialog) {
            return;
        }
        if (errorFields !== null && 'userNameError' in errorFields) {
            setActiveIndex(0);
        } else if (errorFields !== null && 'mobilePhone' in errorFields) {
            setActiveIndex(3);
        } else if (errorFields !== null && 'emailError' in errorFields) {
            setActiveIndex(2);
        } else if (errorFields !== null && 'workSchedulers' in errorFields) {
            setActiveIndex(USER_WORK_SCHEDULE_TAB_INDEX);
        }
        if (errorFields && errorFields.apiError) {
            if (errorFields.message === 'EmailExist') {
                dispatch(setUserErrorFields({'email': true, 'title': errorFields.title}));
                setActiveIndex(1);
            }
            if (errorFields.message === 'userNameError') {
                dispatch(setUserErrorFields({'userName': true, 'title': errorFields.title}));
                setActiveIndex(0);
            }
        }
    }, [isActiveDialog, errorFields])

    useEffect(() => {
        if (!isActiveDialog) {
            return;
        }
        dispatch(setUserField({section: 'user', fieldName: 'actionByUserId', value: user.userId}));
    }, [isActiveDialog, userData?.user?.actionByUserId])

    const showSaveChangesNotification = () => {
        dispatch(setUsersDialogVisible(false));
        // dispatch(setUserDialogUnzipping(false));
        // if (userData?.user?.userId) {
        //     dispatch(getUserDetails(userData?.user?.userId, jwtToken?.jwtToken));
        // }
    }


    const buildUserPayload = (userTrunks: any) => ({
        ...userData.user,
        userTrunks,
        workSchedulers: normalizeUserWorkSchedulers(userData?.user?.workSchedulers),
    });

    const openValidationTab = (validationErrors: any, includePassword = false) => {
        if (validationErrors.userName || (includePassword && validationErrors.password) || validationErrors.roles || validationErrors.branchId) {
            setActiveIndex(0);
        } else if (validationErrors.firstName || validationErrors.lastName || validationErrors.birthDate || validationErrors.recruitedDate) {
            setActiveIndex(1);
        } else if (validationErrors.phoneNo || validationErrors.email || validationErrors.userTrunks) {
            setActiveIndex(2);
        } else if (validationErrors.utc || validationErrors.countryId || validationErrors.languageId || validationErrors.mobilePhone) {
            setActiveIndex(3);
        } else if (validationErrors.workSchedulers) {
            setActiveIndex(USER_WORK_SCHEDULE_TAB_INDEX);
        }
    };

    const createUserData = () => {
        const updatedUser = buildUserPayload((userTrunkIds !== null && userTrunkIds !== undefined) ? userTrunkIds : []);

        const validationErrors = validateUserForm(updatedUser);
        dispatch(setUserErrorFields(validationErrors));
        if (!validationErrors) {
            dispatch(createUser(updatedUser, jwtToken?.jwtToken, dataSort));
            dispatch(setUserDialogUnzipping(false));
        } else {
            openValidationTab(validationErrors, true);
        }
    };

    const updateUserData = () => {
        const nextUserTrunks = trunksIsBlock
            ? (userData?.user?.userTrunks || [])
            : (userTrunkIds !== null && userTrunkIds !== undefined)
                ? userTrunkIds
                : (userData?.user?.userTrunks || []);

        const updatedUser = buildUserPayload(nextUserTrunks);

        const validationErrors = validateUserForm(updatedUser);

        dispatch(setUserErrorFields(validationErrors));
        if ((!validationErrors || validationErrors.password) && !validationErrors?.roles && !validationErrors?.branchId && !validationErrors?.userTrunks && !validationErrors?.mobilePhone && !validationErrors?.email && !validationErrors?.workSchedulers) {
            dispatch(updateUser(updatedUser, jwtToken?.jwtToken, dataSort));
            dispatch(setUserErrorFields(null));
            dispatch(setUserDialogUnzipping(false));
        } else {
            openValidationTab(validationErrors);
        }
    };

    let user_delete_questions = getItem(codes.user_delete_questions);

    const deletedUserInfo = {
        userId: userData?.user?.userId,
        isArchived: true,
        actionByUserId: user?.userId,
        userName: user?.userName
    };

    const progressBar = <ProgressBar mode="indeterminate" style={{height: '2px', maxWidth: '95%'}}></ProgressBar>;
    const userDeletedQuestion = <div>{userDeleteQuestionsText ? userDeleteQuestionsText.text : user_delete_questions ? user_delete_questions : progressBar}</div>

    const deletionToastShow = () => {
        if (!user_delete_questions && !userDeleteQuestionsText && user?.userId) {
            dispatch(getNotification(user.userId, 130, jwtToken?.jwtToken));
        }
        setVisibleDeletedMessage(true);
    }

    const footer = (
        <div className="dialog-footer">
            <Divider/>
            <Toast ref={toast}/>
            <Toast ref={toastBC} position="center"/>
            <div className="buttons">
                {userId && usersActiveTableToggle && hasUsersManagerDeletePermission && <Button icon={windowWidth > 1248 ? "pi pi-trash" : ''}
                                                                                                className="p-button-outlined"
                                                                                                label="Видалити"
                                                                                                onClick={() => {
                                                                                                    deletionToastShow();
                                                                                                }}
                />}
                <Button icon={windowWidth > 1248 ? "pi pi-ban" : ''}
                        className="p-button-outlined"
                        label="Відміна"
                        onClick={() => {
                            dispatch(setUsersDialogVisible(false));
                            dispatch(setUserDialogUnzipping(false));
                        }
                        }
                />
                {!userId && usersActiveTableToggle && hasUsersManagerCreatePermission && <Button icon={windowWidth > 1248 ? "pi pi-save" : ''}
                                                                                                 className=""
                                                                                                 label="Створити та зберегти"
                                                                                                 onClick={() => createUserData()}
                />}
                {userId && (usersActiveTableToggle || usersDialogUnzipping) && hasUsersManagerUpdatePermission && <Button icon={windowWidth > 1248 ? "pi pi-save" : ''}
                                                                                                                          label="Зберегти"
                                                                                                                          onClick={() => {
                                                                                                                              dispatch(updateUserData)
                                                                                                                          }
                                                                                                                          }
                />}
            </div>
        </div>
    );

    const bodyHeader = () => {
        return <UsersListDialogInfo/>;
    }

    const createdUserTime = () => {
        const time = new Date(userData?.user?.userData?.createdDateTime || '').toLocaleString("uk-UA")
        if (userData?.user?.userData?.createdDateTime) {
            return time;
        } else {
            return '-'
        }
    }
    const updatedUserTime = () => {
        const time = new Date(userData?.user?.userData?.updatedDateTime || '').toLocaleString("uk-UA")
        if (userData?.user?.userData?.updatedDateTime) {
            return time;
        } else {
            return '-'
        }
    }

    if (!isActiveDialog) {
        return null;
    }

    return (
        <Dialog
            header={bodyHeader}
            footer={!hasUsersManagerVisionPermission ? null : footer}
            visible={userDialogVisible}
            dismissableMask={false}
            closeOnEscape={false}
            draggable={true}
            blockScroll={true}
            position="top"
            style={{width: '95vw', maxWidth: "1200px", minHeight: "80vh"}}
            onHide={() => showSaveChangesNotification()}
        >
            {userData && <div className="company-info-popup">
                <div className="grid align-items-center">
                    <div className="field col-12 md:col-6">
                        {!!userData.user.id && <div className="item">
                            ID: {userData?.user?.id ? userData.user.id : ''}
                        </div>}
                    </div>
                    <div className="field col-12 md:col-6">
                        {!!userData.user.id && <div className="field col-12 md:col-12 flex flex-wrap p-0 m-0">
                            {userData?.user?.userData?.userCreate && <div className="field col-12 md:col-12 flex flex-wrap m-0">
                                <div className="field col-12 md:col-2 flex p-0 m-0">Створено:</div>
                                <div className="field col-12 md:col-6 flex p-0 m-0">{userData?.user?.userData?.userCreate ? userData?.user?.userData?.userCreate : '-'}</div>
                                <div className="field col-12 md:col-4 flex p-0 m-0">{createdUserTime()}</div>
                            </div>}
                            {userData?.user?.userData?.updatedByUserId && <div className="field col-12 md:col-12 flex flex-wrap m-0">
                                <div className="field col-12 md:col-2 flex p-0 m-0">Оновлено:</div>
                                <div className="field col-12 md:col-6 flex p-0 m-0">{userData?.user?.userData?.userUpdate ? userData?.user?.userData?.userUpdate : '-'}</div>
                                <div className="field col-12 md:col-4 flex p-0 m-0">{updatedUserTime()}</div>
                            </div>}
                        </div>}
                    </div>
                </div>
                <TabView className="user-dialog-info" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="Загальна iнформацiя">
                        {userData && <UsersListDialogGeneralSettings skipBranchesFetch={props.skipBranchesFetch}/>}
                    </TabPanel>
                    <TabPanel header="Дані користувача">
                        <UsersListDialogPersonalInfo/>
                    </TabPanel>
                    <TabPanel header="Контакти">
                        <UserPhoneSettings/>
                    </TabPanel>
                    <TabPanel header="Налаштування">
                        <UserDialogSettings/>
                    </TabPanel>
                    <TabPanel header="Розклад роботи">
                        <UserWorkSchedule/>
                    </TabPanel>
                    {!!userData?.user?.id && <TabPanel header="Черги/Кампанii">
                        <UserDialogCampaign/>
                    </TabPanel>}
                    {userData?.user?.branchId ? <TabPanel header="Пiдпорядкування">
                        <UserBranchInfo/>
                    </TabPanel> : ''}
                </TabView>
                <ConfirmDialog visible={visibleDeletedMessage} onHide={() => setVisibleDeletedMessage(false)} message={userDeletedQuestion}
                               icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити" accept={() => {
                    dispatch(deleteUser(deletedUserInfo, jwtToken?.jwtToken));
                    // @ts-ignore
                    if (deletedUserInfo.userId === props.selectedRowData?.userId) {
                        props.setSelectedRowData(null);
                    }
                    dispatch(setUsersDialogVisible(false));
                }
                }/>
            </div>}
        </Dialog>
    )
}

export default UserListDialog
